import I from "./ghl-ui.es977.js";
import y from "./ghl-ui.es1508.js";
import M from "./ghl-ui.es1506.js";
import j from "./ghl-ui.es1509.js";
import q from "./ghl-ui.es1510.js";
import Q from "./ghl-ui.es1511.js";
import { isProtectedWeekYearToken as F, throwProtectedError as T, isProtectedDayOfYearToken as H } from "./ghl-ui.es1512.js";
import x from "./ghl-ui.es1505.js";
import K from "./ghl-ui.es1466.js";
import { getDefaultOptions as U } from "./ghl-ui.es1513.js";
import V from "./ghl-ui.es723.js";
var Z = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, B = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, G = /^'([^]*?)'?$/, J = /''/g, N = /[a-zA-Z]/;
function de(a, t, e) {
  var v, d, c, u, m, s, p, k, w, g, O, _, h, $, D, E, S, C;
  K(2, arguments);
  var z = String(t), l = U(), n = (v = (d = e == null ? void 0 : e.locale) !== null && d !== void 0 ? d : l.locale) !== null && v !== void 0 ? v : V, R = x((c = (u = (m = (s = e == null ? void 0 : e.firstWeekContainsDate) !== null && s !== void 0 ? s : e == null || (p = e.locale) === null || p === void 0 || (k = p.options) === null || k === void 0 ? void 0 : k.firstWeekContainsDate) !== null && m !== void 0 ? m : l.firstWeekContainsDate) !== null && u !== void 0 ? u : (w = l.locale) === null || w === void 0 || (g = w.options) === null || g === void 0 ? void 0 : g.firstWeekContainsDate) !== null && c !== void 0 ? c : 1);
  if (!(R >= 1 && R <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var W = x((O = (_ = (h = ($ = e == null ? void 0 : e.weekStartsOn) !== null && $ !== void 0 ? $ : e == null || (D = e.locale) === null || D === void 0 || (E = D.options) === null || E === void 0 ? void 0 : E.weekStartsOn) !== null && h !== void 0 ? h : l.weekStartsOn) !== null && _ !== void 0 ? _ : (S = l.locale) === null || S === void 0 || (C = S.options) === null || C === void 0 ? void 0 : C.weekStartsOn) !== null && O !== void 0 ? O : 0);
  if (!(W >= 0 && W <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (!n.localize)
    throw new RangeError("locale must contain localize property");
  if (!n.formatLong)
    throw new RangeError("locale must contain formatLong property");
  var i = M(a);
  if (!I(i))
    throw new RangeError("Invalid time value");
  var P = Q(i), L = y(i, P), Y = {
    firstWeekContainsDate: R,
    weekStartsOn: W,
    locale: n,
    _originalDate: i
  }, A = z.match(B).map(function(r) {
    var o = r[0];
    if (o === "p" || o === "P") {
      var f = q[o];
      return f(r, n.formatLong);
    }
    return r;
  }).join("").match(Z).map(function(r) {
    if (r === "''")
      return "'";
    var o = r[0];
    if (o === "'")
      return X(r);
    var f = j[o];
    if (f)
      return !(e != null && e.useAdditionalWeekYearTokens) && F(r) && T(r, t, String(a)), !(e != null && e.useAdditionalDayOfYearTokens) && H(r) && T(r, t, String(a)), f(L, r, n.localize, Y);
    if (o.match(N))
      throw new RangeError("Format string contains an unescaped latin alphabet character `" + o + "`");
    return r;
  }).join("");
  return A;
}
function X(a) {
  var t = a.match(G);
  return t ? t[1].replace(J, "'") : a;
}
export {
  de as default
};
